import React from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import Colors from "../../utility/Colors";
import aadharlogo from "../../assets/images/aadhar_logo.png";
import { useNavigate } from "react-router-dom";
import constants from "../../common/constants";
import { useDispatch } from "react-redux";
import {
  resetAadharOtp,
  resetCreateAbhaAddress,
  resetEnrolByAadhar,
  resetOtpAadhar,
  resetSuggestionAadhar,
} from "./reducer/abhaAadhar/slice";

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Card
      sx={{
        width: "100%",
        marginTop: "10px",
        // minHeight: "100vh",
        borderRadius: "10px",
        p: 2,
        boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
        "&:hover": {
          boxShadow: "#008080 0px 2px 5px",
        },
      }}
    >
      <Grid spacing={2}>
        <Grid
          sm={12}
          xs={12}
          // sx={{ display: "flex", justifyContent: "center" }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              color: "rgb(38, 68, 136)",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            Create ABHA Number
          </Typography>
          <Typography sx={{ textAlign: "center" }}>
            Please choose one of the below option to start with the creation of
            your ABHA
          </Typography>
        </Grid>
        <Grid
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "center", marginTop: "30px" }}
          onClick={() => {
            dispatch(resetCreateAbhaAddress());
            dispatch(resetAadharOtp());
            dispatch(resetEnrolByAadhar());
            dispatch(resetOtpAadhar());
            dispatch(resetSuggestionAadhar());
            navigate(constants.PATH_CREATE_ABHA);
          }}
        >
          <Card
            sx={{
              padding: "30px",
              borderRadius: "10px",
              margin: "0px",
              boxShadow: "rgba(38, 38, 38, 0.4) 0px 1px 3px",
              "&:hover": {
                border: "2px solid rgb(214,96,37)",
                boxShadow: "none",
                transform: "scale(1.05)",
                transition: "0.2s ease-in",
              },
              maxWidth: "330px",
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <img src={aadharlogo} alt="name" height={"56px"} />
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "rgb(38, 68, 136)",
                    fontWeight: "700",
                  }}
                >
                  Create your ABHA number using
                </Typography>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "rgb(214, 96, 37)",
                    fontWeight: "700",
                  }}
                >
                  Aadhaar
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Card>
  );
};
export default Register;
